export const listMiniSiteStyle = theme => ({
    contentAll: {
        [theme.breakpoints.up('sm')]: {
            height: 'calc(100vh - 64px)'
        },
        overflow: 'auto'
    },
    root: {
        width: '100%',
        margin: 'auto'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
})